import { createContext } from 'react';

export type ThemeModeContextValue = {
  mode: 'dark' | 'light';
  toggleMode: () => void;
};

export const ThemeModeContext = createContext<ThemeModeContextValue>({
  mode: 'dark',
  toggleMode: () => {},
});
